import {
  FontAwesomeIcon,
} from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import Link from 'components/core/Link';

const Anchor = styled(Link)`
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    align-items: center;
    width: 24rem;
    padding-right: 0.5rem;
    border-radius: 0.25rem;
    border: solid 1px #364153;
    cursor: pointer;
    overflow: hidden;
    text-decoration: none;
    &:hover svg {
        visibility: visible!important;
    }
`;

const FeaturedResource = ({ url, title, summary, img }: { url: string, title: string, summary: string, img: string }): React.ReactElement => (
    <Anchor
        to={url}
        openNewTab
    >
        <div
            style={{
                width: '8rem',
                height: '6rem',
                flexShrink: '0',
                overflow: 'hidden',
                borderRight: '1px solid #364153',
            }}
        >
            <img
                src={img}
                alt=""
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                }}
            />
        </div>
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                height: '6rem',
                flex: '1',
            }}
        >
            <Link style={{textAlign: 'start'}}>
                <Typography variant='h6'>
                    {title} <FontAwesomeIcon
                        icon={faExternalLink}
                        style={{
                            visibility: 'hidden',
                            display: 'inline-block',
                            marginBottom: '0.125rem',
                            color: '#1b75bb',
                            fontSize: '0.75rem',
                        }}
                    />
                </Typography>
                <Typography variant='body2'
                    style={{
                        color: 'black',
                        overflow: 'hidden',
                        display: '-webkit-box',
                        boxOrient: 'vertical',
                        lineClamp: 3,
                        margin: '0',
                    }}
                >
                    {summary}
                </Typography>
            </Link>
        </div>
    </Anchor>
)

export default FeaturedResource;
